(function() {
	'use strict';

	angular.module('cmsApp').config(stateConfig);
	
	stateConfig.$inject = [ '$stateProvider', '$urlRouterProvider',
			'GLOBAL_URL' ];

	function stateConfig($stateProvider, $urlRouterProvider, GLOBAL_URL) {
		$urlRouterProvider.otherwise("/category");
		$stateProvider
				.state(
						'category',
						{
							url : '/category',
							data : {
								pageTitle : 'Hướng dẫn'
							},
							views : {
								'content@' : {
									templateUrl : GLOBAL_URL
											+ 'partial?uri=admin/layout/ListCategory',
									controller : 'CMSController',
									controllerAs : 'vm'
								}
							}
						})
						.state(
						'createNew',
						{
							url : '/createNew/:documentId',
							data : {
								pageTitle : 'Tạo mới'
							},
							params: { documentId: {squash: true, value: null }},
							views : {
								'content@' : {
									templateUrl : GLOBAL_URL
											+ 'partial?uri=admin/layout/createNewCategory',
									controller : 'CMSController',
									controllerAs : 'vm'
								}
							}
						})
				;
	}
})();
